"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/**
 * @param userBackground The current state of blur background toggle
 * @returns {(function(*): void)|*}
 */
function setUserBackground(userBackground) {
  return (0, _actionUtils.actionCreator)(_types.SET_BACKGROUND_OPTION, {
    userBackground: userBackground
  });
}
var _default = exports["default"] = setUserBackground;